export default "__VITE_ASSET__DBQ643HG__"